import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@e2n/ui';
import { useState } from 'react';
import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function Mitarbeiter({
  rotationsplan,
}: {
  rotationsplan: Rotationsplan;
}) {
  const { t } = useTranslation();
  const percentage =
    (rotationsplan.abgeschlosseneStationen.length * 100) /
    rotationsplan.amountOfStationen;
  const [open, setOpen] = useState(false);
  const hasUeberschneidungen = rotationsplan.hasUeberschneidungen();

  return (
    <div className="flex items-center justify-between">
      <div className="flex gap-2 items-center">
        <Avatar>
          <AvatarImage
            alt={rotationsplan.mitarbeiter.getName()}
            src={rotationsplan.mitarbeiter.imgUrl}
          />
          <AvatarFallback>
            {rotationsplan.mitarbeiter.getInitials()}
          </AvatarFallback>
        </Avatar>
        <div className="flex flex-col min-w-0">
          <div className="text-sm text-neutrals-900 truncate">
            {rotationsplan.mitarbeiter.vorname +
              ' ' +
              rotationsplan.mitarbeiter.nachname}
          </div>
          <div className="text-xs text-neutrals-700">
            {rotationsplan.currentLehrjahr +
              ' ⋅ ' +
              rotationsplan.beruf.abkuerzung}
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2">
        {hasUeberschneidungen && (
          <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger
              onMouseEnter={() => setOpen(true)}
              onMouseLeave={() => setOpen(false)}>
              <div className="text-primary-red-400 text-xl font-semibold">
                <FontAwesomeIcon icon={faCircleExclamation} />
              </div>
            </PopoverTrigger>
            <PopoverContent
              side="bottom"
              align="end"
              className="flex flex-col w-full text-sm bg-neutrals-100 text-primary-red-400">
              {t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.konflikt.title',
              )}
            </PopoverContent>
          </Popover>
        )}
        <div className="relative w-6 h-6 rounded-full">
          <svg className="w-full h-full" viewBox="0 0 100 100">
            <circle
              className="text-neutrals-300 stroke-current"
              strokeWidth="10"
              cx="50"
              cy="50"
              r="45"
              fill="transparent"
            />
            {percentage > 0 && (
              <circle
                className={
                  'text-primary-blue-600 progress-ring__circle stroke-current'
                }
                strokeWidth="10"
                strokeLinecap="round"
                cx="50"
                cy="50"
                r="45"
                fill="transparent"
                strokeDashoffset={280 - (280 * percentage) / 100}
              />
            )}
          </svg>
        </div>
        <div className="flex items-baseline gap-1">
          <div className="text-neutrals-900 font-semibold text-sm">
            {rotationsplan.abgeschlosseneStationen.length}
          </div>
          <div className="text-neutrals-700 text-xs">/</div>
          <div className="text-neutrals-700 text-xs">
            {rotationsplan.amountOfStationen}
          </div>
        </div>
      </div>
    </div>
  );
}
